import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ActionsTab } from './ActionsTab';
import { CleanupTab } from './CleanupTab';
import { ConfigTab } from './ConfigTab';

type TabType = 'actions' | 'config' | 'cleanup';

export const AdminManager: React.FC = () => {
  const location = useLocation();

  const getTabFromPath = (): TabType => {
    const p = location.pathname;
    if (p.includes('/config')) return 'config';
    if (p.includes('/cleanup')) return 'cleanup';
    return 'actions';
  };

  const [activeTab, setActiveTab] = useState<TabType>(getTabFromPath);
  useEffect(() => { setActiveTab(getTabFromPath()); }, [location.pathname]);

  return (
    <div className="space-y-6">
      {activeTab === 'actions' && <ActionsTab />}
      {activeTab === 'config' && <ConfigTab />}
      {activeTab === 'cleanup' && <CleanupTab />}
    </div>
  );
};
